<template>
  <div class="hris-page">
    <div class="hris-page-inner">
    <div class="hris-page-header">
      <span class="hris-page-eyebrow">Online Forms</span>
      <h1 class="hris-page-title">Half Day</h1>
      <p class="hris-page-subtitle">Request a half-day adjustment to your shift schedule.</p>
    </div>

    <div class="hris-form-narrow">
    <div class="hris-form-banner hris-form-banner-warning">
      Shift hours covered is {{ halfShift }} hours.
    </div>

    <q-form>
      <div class="hris-form-section">
        <h2 class="hris-form-section-title">Inclusive Date</h2>
        <div class="hris-form-row">
          <div class="hris-form-field" style="flex-basis: 100%;">
            <q-input v-model="dateToday" outlined dense color="green" readonly ></q-input>
          </div>
        </div>
      </div>

      <div class="hris-form-section">
        <h2 class="hris-form-section-title">Inclusive Time</h2>
        <div class="hris-form-row">
          <div class="hris-form-field">
            <label class="hris-form-label">Original Time-In</label>
            <q-input :value="originalTimeIn" outlined dense color="green" readonly>
              <template v-slot:append>
                <q-icon name="fa fa-clock" class="cursor-pointer">
                  <q-popup-proxy transition-show="flip-down" transition-hide="flip-up">
                    <q-time v-model="form.selectedOriginalTimeIn" :minute-options="minuteOptions" landscape color="green" minimal>
                      <div class="row items-center justify-end q-gutter-xs">
                        <q-btn label="Cancel" color="green" style="width: 80px" flat v-close-popup ></q-btn>
                        <q-btn label="OK" color="green" style="width: 80px" flat @click="saveTime(form.selectedOriginalTimeIn)" v-close-popup ></q-btn>
                      </div>
                    </q-time>
                  </q-popup-proxy>
                </q-icon>
              </template>
            </q-input>
          </div>
          <div class="hris-form-field">
            <label class="hris-form-label">Original Time-Out</label>
            <q-input v-model="originalTimeOut" outlined dense color="green" readonly />
          </div>
        </div>
        <div class="hris-form-row">
          <div class="hris-form-field">
            <label class="hris-form-label">Halfday Time-In</label>
            <q-select v-model="newTimeIn" @input="setHalfTime(newTimeIn)" :options="hdOptions" options-cover outlined dense color="green" />
          </div>
          <div class="hris-form-field">
            <label class="hris-form-label">Halfday Time-Out</label>
            <q-input v-model="newTimeOut" outlined dense color="green" readonly />
          </div>
        </div>
      </div>

      <div class="hris-form-section">
        <h2 class="hris-form-section-title">Reason</h2>
        <div class="hris-form-row">
          <div class="hris-form-field" style="flex-basis: 100%;">
            <q-input type="textarea" v-model="form.halfdayReason" outlined dense color="green" maxlength="250" clearable bottom-slots counter hint="Max 250 characters" />
          </div>
        </div>
      </div>

      <div class="hris-form-actions">
        <q-btn unelevated class="hris-q-outline" @click="resetForm" label="Reset" style="min-width: 140px;" />
        <q-btn unelevated class="hris-q-primary" @click="submitApplication" :loading="loading" label="Submit" style="min-width: 140px;">
          <template v-slot:loading>
            <q-spinner color="green" class="on-left" />
            Sending...
          </template>
        </q-btn>
      </div>
    </q-form>
    </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { date } from 'quasar';

let today = Date.now();
let dateToday = 'Today: ' + date.formatDate(today, ' dddd,  MMMM DD, YYYY');
const scrollToTop = () => {
  const c = document.documentElement.scrollTop || document.body.scrollTop;
  if (c > 0) {
    window.requestAnimationFrame(scrollToTop);
    window.scrollTo(0, c - c / 8);
  }
};

export default {
  name: 'Halfday',
  props: ['value'],
  data() {
    return {
      shiftHours: 0,
      halfShift: 0,
      loading: false,
      dateToday,
      form: {
        halfdayDate: '',
        selectedOriginalTimeIn: '',
        selectedOriginalTimeOut: '',
        halfdayNewTimeIn: '',
        halfdayNewTimeOut: '',
        halfdayReason: ''
      },
      originalTimeIn: 'Please select a time...',
      originalTimeOut: 'Please select original time-in...',
      newTimeIn: 'Please select original time-in...',
      newTimeOut: 'Please select original time-in...',
      minuteOptions: [0, 30],
      hdOptions: [],
    }
  },
  methods: {
    saveTime: function(timeSent) {
      this.shiftHours = this.userData.shift_hours;
      var tempTime = timeSent.split(':');
      var newTime = date.buildDate({ hours: tempTime[0], minutes: tempTime[1] });
      var oNewTimeIn = date.formatDate(newTime, 'hh:mm A');
      var hdNewTimeInPlus = date.addToDate(newTime, { hours: this.halfShift });
      var hdNewTimeIn = date.formatDate(hdNewTimeInPlus, 'hh:mm A');
      var oNewTimeOutPlus = date.addToDate(newTime, { hours: this.shiftHours });
      var oNewTimeOut = date.formatDate(oNewTimeOutPlus, 'hh:mm A');

      this.originalTimeIn = oNewTimeIn;
      this.originalTimeOut = oNewTimeOut;
      this.newTimeIn = 'Please select halfday time-in...';
      this.newTimeOut = 'Please select halfday time-in...';
      this.hdOptions = [oNewTimeIn, hdNewTimeIn];
      this.form.selectedOriginalTimeOut = date.formatDate(oNewTimeOutPlus, 'HH:mm');
    },

    setHalfTime: function(startTime) {
      var newDate = date.extractDate(startTime, 'hh:mm A');
      var hdNewTimeOutPlus = date.addToDate(newDate, { hours: this.halfShift });
      var hdNewTimeOut = date.formatDate(hdNewTimeOutPlus, 'hh:mm A');

      this.newTimeOut = hdNewTimeOut;
      this.form.halfdayNewTimeIn = date.formatDate(newDate, 'HH:mm');
      this.form.halfdayNewTimeOut = date.formatDate(hdNewTimeOutPlus, 'HH:mm');
    },

    submitApplication: function() {
      this.form.halfdayDate = date.formatDate(today, 'YYYY-MM-DD');

      if (this.form.selectedOriginalTimeIn == '' || this.form.halfdayNewTimeIn == '' ||
        this.form.halfdayReason == '') {
        this.$q.notify({
          color: 'red-6',
          textColor: 'white',
          icon: 'fa fa-exclamation-circle',
          message: 'Please fill-in all necessary details.'
        });
      } else {
        this.loading = true;

        let formData = new FormData();
        formData.append('form_data', JSON.stringify(this.form));

        axios.create({
          baseURL: this.apiUrl,
          headers: {
            'Authorization': `Bearer ${this.token}`
          }
        }).post('/online-forms/applications/halfday', formData).then((res) => {
          setTimeout(() => {
            this.loading = false;
            this.$q.notify({
              color: 'green-7',
              textColor: 'white',
              icon: 'fa fa-shipping-fast',
              message: 'Halfday Application Submitted'
            });
            this.resetForm();
          }, 1000);
        });
      }
    },

    resetForm: function() {
      var self = this;
      Object.keys(this.form).forEach(function(key, index) {
        self.form[key] = '';
      });
      this.originalTimeIn = 'Please select a time...';
      this.originalTimeOut = 'Please select original time-in...';
      this.newTimeIn = 'Please select original time-in...';
      this.newTimeOut = 'Please select original time-in...';
      setTimeout(() => {
        scrollToTop();
      }, 200);
    }
  },
  mounted() {
    this.halfShift = this.userData.shift_hours / 2;
  }
}
</script>
<style scoped>
</style>
